import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/tomos';
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-white/5 bg-ink-2" data-id="element-15" data-mp="plslc7o6v6at">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-16" data-mp="autf33atstue">
        <h2 className="text-center font-display text-2xl font-black text-white sm:text-4xl" data-id="element-17" data-mp="ftmwv7x5b70d">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-18" data-mp="1wrj525y8rdz">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-plata/20 bg-ink p-6" data-id="element-19" data-mp="5tvygv5gs7v0" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-20" data-mp="1r8te8c1ukfgl">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-plata/15 px-3 py-1 text-xs font-bold text-plata" data-id="element-21" data-mp="3id54555371a9">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-22" data-mp="3dd8xsz8x2xrj" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-23" data-mp="3r5yld843gaqr">
                  <span className="text-white/40 line-through" data-id="element-24" data-mp="3n4wkynyfxsn7">{b.price}</span>{' '}
                  <span className="text-rojo-soft" data-id="element-25" data-mp="2zfals0i2jdf7">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-26" data-mp="2uh0rds464gun">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-27" data-mp="2uitwv431ov12">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-rojo/40 bg-rojo/10 p-6 text-center" data-id="element-28" data-mp="33gw6u94ray0h">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-29" data-mp="npi124mixioy">
            Valor total de los bonos: <span className="text-white/50 line-through" data-id="element-30" data-mp="irgbr1yi8n51">$42</span>{' '}
            <span className="text-[15px] text-plata" data-id="element-31" data-mp="itazeo15utct">HOY GRATIS CON TU MANUAL</span>
          </p>
        </div>
      </div>
    </section>;
}